import * as React from 'react';
import { SVGProps } from 'react';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
const DoubleCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g strokeLinecap="round" fill="none" strokeLinejoin="round">
      <path d="m10 11.5 3 3m4-4-4 4-2.917-2.917M9 14.5l-2-2m7-3-1 1" />
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2Z" />
    </g>
  </svg>
);

export default DoubleCheck;
